var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNearMes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18s6-5.686 6-9A6 6 0 106 9c0 3.314 6 9 6 9zm0-6a3 3 0 100-6 3 3 0 000 6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.23c-1.829.49-3 1.245-3 2.09C4 19.8 7.582 21 12 21s8-1.2 8-2.68c0-.845-1.171-1.6-3-2.09",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAxOEMxMiAxOCAxOCAxMi4zMTM3IDE4IDlDMTggNS42ODYyOCAxNS4zMTM3IDMgMTIgM0M4LjY4NjI4IDMgNiA1LjY4NjI4IDYgOUM2IDEyLjMxMzcgMTIgMTggMTIgMThaTTEyIDEyQzEzLjY1NjkgMTIgMTUgMTAuNjU2OSAxNSA5QzE1IDcuMzQzMTQgMTMuNjU2OSA2IDEyIDZDMTAuMzQzMSA2IDkgNy4zNDMxNCA5IDlDOSAxMC42NTY5IDEwLjM0MzEgMTIgMTIgMTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTcgMTYuMjI5MkM1LjE3MTA3IDE2LjcyMDMgNCAxNy40NzQ3IDQgMTguMzIwOEM0IDE5LjgwMDUgNy41ODE3MiAyMS4wMDAxIDEyIDIxLjAwMDFDMTYuNDE4MyAyMS4wMDAxIDIwIDE5LjgwMDUgMjAgMTguMzIwOEMyMCAxNy40NzQ3IDE4LjgyODkgMTYuNzIwMyAxNyAxNi4yMjkyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgNearMes as ReactComponent };